import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c1cc1cba")

_pushScopeId("data-v-c1cc1cba")
const _hoisted_1 = { class: "image-style-panel" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 裁剪图片")
const _hoisted_3 = { class: "clip" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "title" }, "按形状裁剪：", -1)
const _hoisted_5 = { class: "shape-clip" }
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = { class: "filter" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 设置滤镜")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 替换图片")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 重置样式")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 设为背景")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconTailoring = _resolveComponent("IconTailoring")
  const _component_Button = _resolveComponent("Button")
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")
  const _component_IconDown = _resolveComponent("IconDown")
  const _component_Popover = _resolveComponent("Popover")
  const _component_Slider = _resolveComponent("Slider")
  const _component_IconColorFilter = _resolveComponent("IconColorFilter")
  const _component_ElementFlip = _resolveComponent("ElementFlip")
  const _component_Divider = _resolveComponent("Divider")
  const _component_ElementOutline = _resolveComponent("ElementOutline")
  const _component_ElementShadow = _resolveComponent("ElementShadow")
  const _component_IconTransform = _resolveComponent("IconTransform")
  const _component_FileInput = _resolveComponent("FileInput")
  const _component_IconUndo = _resolveComponent("IconUndo")
  const _component_IconTheme = _resolveComponent("IconTheme")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "origin-image",
      style: { backgroundImage: `url(${_ctx.handleElement.src})` }
    }, null, 4),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Button, {
          style: {"flex":"5"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clipImage()))
        }, {
          default: _withId(() => [
            _createVNode(_component_IconTailoring, { class: "btn-icon" }),
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_Popover, {
          trigger: "click",
          visible: _ctx.clipPanelVisible,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.clipPanelVisible = $event))
        }, {
          content: _withId(() => [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shapeClipPathOptions, (item, key) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "shape-clip-item",
                    key: key,
                    onClick: ($event: any) => (_ctx.presetImageClip(key))
                  }, [
                    _createVNode("div", {
                      class: "shape",
                      style: { backgroundImage: `url(${_ctx.handleElement.src})`, clipPath: item.style }
                    }, null, 4)
                  ], 8, ["onClick"]))
                }), 128))
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ratioClipOptions, (type) => {
                return (_openBlock(), _createBlock(_Fragment, {
                  key: type.label
                }, [
                  (type.label)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(type.label) + "：", 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ButtonGroup, { class: "row" }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(type.children, (item) => {
                        return (_openBlock(), _createBlock(_component_Button, {
                          style: {"flex":"1"},
                          key: item.key,
                          onClick: ($event: any) => (_ctx.presetImageClip('rect', item.ratio))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(item.key), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ], 64))
              }), 128))
            ])
          ]),
          default: _withId(() => [
            _createVNode(_component_Button, {
              class: "no-padding",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_IconDown)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible"])
      ]),
      _: 1
    }),
    _createVNode(_component_Popover, { trigger: "click" }, {
      content: _withId(() => [
        _createVNode("div", _hoisted_7, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterOptions, (filter) => {
            return (_openBlock(), _createBlock("div", {
              class: "filter-item",
              key: filter.key
            }, [
              _createVNode("div", _hoisted_8, _toDisplayString(filter.label), 1),
              _createVNode(_component_Slider, {
                class: "filter-slider",
                max: filter.max,
                min: filter.min,
                step: filter.step,
                value: filter.value,
                onChange: value => _ctx.updateFilter(filter, value)
              }, null, 8, ["max", "min", "step", "value", "onChange"]),
              _createVNode("div", _hoisted_9, _toDisplayString(filter.value), 1)
            ]))
          }), 128))
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_Button, { class: "full-width-btn" }, {
          default: _withId(() => [
            _createVNode(_component_IconColorFilter, { class: "btn-icon" }),
            _hoisted_10
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ElementFlip),
    _createVNode(_component_Divider),
    _createVNode(_component_ElementOutline),
    _createVNode(_component_Divider),
    _createVNode(_component_ElementShadow),
    _createVNode(_component_Divider),
    _createVNode(_component_FileInput, {
      onChange: _cache[3] || (_cache[3] = files => _ctx.replaceImage(files))
    }, {
      default: _withId(() => [
        _createVNode(_component_Button, { class: "full-width-btn" }, {
          default: _withId(() => [
            _createVNode(_component_IconTransform, { class: "btn-icon" }),
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Button, {
      class: "full-width-btn",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetImage()))
    }, {
      default: _withId(() => [
        _createVNode(_component_IconUndo, { class: "btn-icon" }),
        _hoisted_12
      ]),
      _: 1
    }),
    _createVNode(_component_Button, {
      class: "full-width-btn",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setBackgroundImage()))
    }, {
      default: _withId(() => [
        _createVNode(_component_IconTheme, { class: "btn-icon" }),
        _hoisted_13
      ]),
      _: 1
    })
  ]))
})